import Vue from 'vue'
import {getWithPagination, UsersResource} from '../../util/api'

const initialState = {
  objects: {},
  currentUser: null,
  createdObject: null, // The most recent Object to be created
  updatedObject: null, // The most recent Object to be updatd
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

const state = { ...initialState }

const mutations = {
  SET_CURRENT_USER (state, object) {
    state.currentUser = object
  },
  SET_USERS (state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (objects.hasOwnProperty(key)) {
        if (objects[key].deleted_at === null) {
          // Stage the update so we can just do one Vue.set
          updatedObjects[objects[key].id] = objects[key]
        } else if (state.objects.hasOwnProperty(objects[key].id)) {
          // Immediately delete the object
          Vue.delete(state.objects, objects[key].id)
        }
      }
    }
    state.objects = {
      ...state.objects,
      ...updatedObjects
    }
  },
  SET_USER (state, object) {
    if (object.deleted_at === null) {
      Vue.set(state.objects, object.id, object)
    } else {
      Vue.delete(state.objects, object.id)
    }
  },
  UNSET_USER (state, object) {
    Vue.delete(state.objects, object.id)
  },

  CREATED_USER (state, object) {
    state.createdObject = object
  },
  UPDATED_USER (state, object) {
    state.updatedObject = object
  },
  DELETED_USER (state, object) {
    state.updatedObject = object
  },

  // Progress States
  GET_USER_IN_PROGRESS (state, value) {
    state.getInProgress = value
  },
  CREATE_USER_IN_PROGRESS (state, value) {
    state.createInProgress = value
  },
  UPDATE_USER_IN_PROGRESS (state, value) {
    state.updateInProgress = value
  },
  DELETE_USER_IN_PROGRESS (state, value) {
    state.deleteInProgress = value
  },

  USERS_CLEAR_ALL (state) {
    for (let key in initialState) {
      Vue.set(state, key, initialState[key])
    }
  }
}

const getters = {
  isAdmin: state => {
    return state.currentUser !== null && state.currentUser.role === 'Admin'
  },
  activeUsers: state => {
    return Object.keys(state.objects)
      .map(k => state.objects[k])
      .filter(item => {
        return !!item.status
      })
  }
}

const actions = {
  getCurrentUser ({commit}) {
    // Get the User objkect of the currenly logged in user
    try {
      UsersResource.get({id: 'me'}).then((response) => {
        commit('SET_CURRENT_USER', response.body)
      }, () => {
        // @TODO: Implement error handling
      })
    } catch (ex) {
      // Request was most likely cancelled due to existing in flight request
    }
  },
  getUser ({commit}, id) {
    // Check if we have an up-to-date version of the object. If not, get it.
    try {
      UsersResource.get({id: id}).then((response) => {
        commit('SET_USER', response.body)
      }, () => {
        // @TODO: Implement error handling
      })
    } catch (ex) {
      // Request was most likely cancelled due to existing in flight request
    }
  },

  getUsers ({commit}, params) {
    // Download all users
    getWithPagination(UsersResource, params, response => {
      // Note: Pagination requests return the objects under the 'data' key
      commit('SET_USERS', response.body.data)
    }, () => {
      // Completion handler
    }, () => {
      // Error handler
    })
  },

  createUser ({commit}, object) {
    // Create (POST) a USER
    commit('CREATED_USER', null)
    commit('CREATE_USER_IN_PROGRESS', true)
    UsersResource.save({}, object).then((response) => {
      commit('SET_USER', response.body)
      commit('CREATED_USER', response.body)
      commit('CREATE_USER_IN_PROGRESS', false)
    }, () => {
      console.error('Create USER Failed')
      commit('CREATED_USER', null)
      commit('CREATE_USER_IN_PROGRESS', false)
    })
  },

  updateUser ({state, commit}, object) {
    // Update (PUT) a USER
    commit('UPDATED_USER', null)
    commit('UPDATE_USER_IN_PROGRESS', true)
    UsersResource.update({id: object.id}, object).then((response) => {
      commit('UPDATE_USER_IN_PROGRESS', false)
      commit('UPDATED_USER', response.body)
      commit('SET_USER', response.body)
      if (response.body.id === state.currentUser.id) {
        commit('SET_CURRENT_USER', response.body)
      }
    }, () => {
      commit('UPDATE_USER_IN_PROGRESS', false)
      commit('UPDATED_USER', null)
    })
  },

  deleteUser ({commit}, object) {
    // Delete a User
    commit('DELETED_USER', null)
    commit('DELETE_USER_IN_PROGRESS', object)
    UsersResource.delete({id: object.id}).then(() => {
      commit('DELETE_USER_IN_PROGRESS', false)
      commit('DELETED_USER', object)
      commit('UNSET_USER', object)
    }, () => {
      commit('DELETE_USER_IN_PROGRESS', false)
      commit('DELETED_USER', null)
    })
  },

  clearAll ({commit}) {
    commit('USERS_CLEAR_ALL')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
